import VacationMasterPage from './VacationMasterPage';

export default VacationMasterPage;
